<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tsJsG9/tc-custom/9781459234796.jpg?1728954633242" alt="This image is the cover for the book Playing the Greek's Game, What His Money Can't Buy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Playing the Greek's Game, What His Money Can't Buy
      </h1>
      <p class="bookDescription body article font2">
        <p>Few dare to defy global hotel magnate Zak Constantinideshe's the boss and everyone knows it! So when his London interior designer turns out to have dug her gold-digging claws into his brother, Zak's solution is to transfer herto New York!<br/><br/>Emma may have more skeletons in her closet than most, but Zak's brother <i>isn't</i> one of them. The temptation to take her impossibly arrogant boss down a peg or three is too much to resist. So while with him in New York, she'll play the role he's given her and <i>be every bit as bad</i> as he thinks she is.<br/><br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sharon Kendrick
      </h2>
      
      <p class="authorDescription body article">Sharon Kendrick started story-telling at the age of eleven and has never stopped. She likes to write fast-paced, feel-good romances with heroes who are so sexy they&rsquo;ll make your toes curl! She&#160;lives in the beautiful city of Winchester &ndash; where she can see the cathedral from her window (when standing on tip-toe!). She has two children, Celia and Patrick and her passions include music, books, cooking and eating &ndash; and drifting into daydreams while working out new plots.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?dfd79d50